// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202605081457/js/" + chunkId + "." + {"44":"b9dd5bb7","225":"00cb08b3","481":"dfdd758d","486":"0f943b5f","770":"a0e27921"}[chunkId] + ".0.3824152387205728.chunk.js";
};